import React, { useState } from "react";
import AdminPanel from "./Components/AdminPannel";
import BlogList from "./Components/BlogList";
// import Login from "./Components/login";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import BlogDetails from "./Components/blogDetails";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import UserDashboard from "./Components/userDashboard";
function App() {
  // const [isAuthenticated, setIsAuthenticated] = useState(false); // Authentication state

  const queryClient = new QueryClient();


  return (
    <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BlogList />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        {/* <Route
          path="/admin"
          element={
            isAuthenticated ? (
              <AdminPanel />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        /> */}
        <Route path ="admin" element={<AdminPanel/>}/>
        <Route path="/dashboard" element={<UserDashboard/>} /> 
        <Route path="/admin/:id" element={<AdminPanel />} />

        {/* <Route path="/login" element={<Login setIsAuthenticated={setIsAuthenticated} />} /> */}
      </Routes>
    </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
